import { RouteConfig } from "vue-router";
import CategoryList from "@/views/handbook/CategoryList.vue";
import Handbook from "@/views/handbook/Handbook.vue";

const routes: Array<RouteConfig> = [
  {
    path: "",
    components: {
      default: CategoryList,
      details: Handbook,
      lists: CategoryList,
    },
    meta: {
      title: "Handbook",
      requiresAuth: true,
    },
  },
  {
    path: "details",
    name: "lists",
    components: {
      default: Handbook,
      details: Handbook,
      lists: CategoryList,
    },
    meta: {
      title: "Handbook",
      requiresAuth: true,
    },
  },
];

export default routes;
